import { ChangeDetectorRef, Component, HostBinding, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { retry } from 'rxjs/operators';
import { FitnessMediaService } from '../../services/fitness-media.service';

@Component({ selector: 'app-fitness-media-image', template: `
    <img *ngIf="url && !failed" [src]="url" [alt]="alt" loading="lazy" decoding="async"
      [style.max-width]="maxWidth" [style.max-height]="maxHeight" [ngStyle]="dwStyle" (load)="loading = false" (error)="imageFailed()">
    <span *ngIf="loading && showStatus" role="status" aria-label="Loading image"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
    <button *ngIf="failed && showStatus" type="button" class="btn btn-sm btn-light" (click)="reload()" aria-label="Retry loading image">Retry image</button>`,
    styles: [':host {display:inline-block; max-width:100%;} img {display:block;max-width:100%;height:auto;}'] })
export class FitnessMediaImageComponent implements OnChanges, OnDestroy {
    @Input() showStatus = false;
    @Input() mediaId: number;
    @Input() activityPhoto = false;
    @Input() importedProfilePhoto = false;
    @Input() alt = '';
    @Input() width: number;
    @Input() height: number;
    @Input() maxWidth = '100%';
    @Input() maxHeight: string;
    @Input() dwStyle: { [key: string]: any } = {};
    @HostBinding('style.width') get hostWidth(): string { return this.dwStyle.width || null; }
    url = '';
    failed = false;
    loading = false;
    private _fallbackUrl = '';
    private request = new Subscription();
    constructor(private media: FitnessMediaService, private changeDetector: ChangeDetectorRef) {}
    private _imageKey = '';
    ngOnChanges(): void {
        const key = JSON.stringify([this.mediaId, this.width, this.height, this.activityPhoto, this.importedProfilePhoto]);
        if (key === this._imageKey) { return; }
        this._imageKey = key; this.load();
    }
    reload(): void { this.media.invalidate(this.mediaId); this.load(); }
    imageFailed(): void {
        const fallback = this._fallbackUrl;
        this._fallbackUrl = '';
        if (fallback && fallback !== this.url) { this.url = fallback; return; }
        this.failed = true; this.loading = false;
    }
    private load(): void {
        this.request.unsubscribe(); this.url = ''; this._fallbackUrl = ''; this.failed = false; this.loading = this.mediaId > 0;
        this.request = this.media.load(this.mediaId).pipe(retry(1)).subscribe(record => {
            this.url = this.activityPhoto ? this.media.activityPhotoUrl(record, this.width) : this.media.url(record, this.width, this.height);
            if (this.importedProfilePhoto && !this.activityPhoto) {
                this._fallbackUrl = this.media.activityPhotoUrl(record, this.width);
            }
            if (!this.url) { this.loading = false; this.failed = this.mediaId > 0; }
            this.changeDetector.markForCheck();
        }, () => { this.loading = false; this.failed = true; this.changeDetector.markForCheck(); });
    }
    ngOnDestroy(): void { this.request.unsubscribe(); }
}
